import api from './ajax.js';

document.addEventListener("DOMContentLoaded", function () {
	// Function to validate email using a regular expression
	function isValidEmail(email) {
		const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
		return emailRegex.test(email);
	}

	// Function to validate phone number (allow only digits and check length)
	function isValidPhoneNumber(phoneNumber) {
		const phoneRegex = /^\d+$/;  // Allow only digits
		return phoneRegex.test(phoneNumber);
	}

	// Function to show the error message below the input
	function showErrorMessage(input, message) {
		// Check if the error message already exists
		let errorDiv = document.querySelector(`#${input.id}-error-message`);
		if (!errorDiv) {
			// Create the error message div if it doesn't exist
			errorDiv = document.createElement('div');
			errorDiv.id = `${input.id}-error-message`;
			errorDiv.classList.add('invalid-feedback', 'd-block');  // Bootstrap classes for error
			errorDiv.style.display = 'block'; // Ensure it's visible
			input.parentElement.appendChild(errorDiv);
		}

		// Set the error message text
		errorDiv.textContent = message;

		console.log(errorDiv);
	}

	// Function to remove the error message
	function removeErrorMessage(input) {
		const errorDiv = document.querySelector(`#${input.id}-error-message`);
		if (errorDiv) {
			errorDiv.remove();
		}
	}

	// Function to trigger the search based on the email value
	async function searchStaffByEmail() {
		const emailInput = document.querySelector('#staffCardCollapse input#id_email');
		const email = emailInput ? emailInput.value.trim() : '';

		// Check if the email is valid
		if (isValidEmail(email)) {
			// Call the method to get staff by email
			const staff = await api.getStaffByEmail(email);

			// If staff is found, show error message
			if (staff.body.length > 0) {
				showErrorMessage(emailInput, 'This email has already been used.');
			} else {
				removeErrorMessage(emailInput);
			}
		} else {
			removeErrorMessage(emailInput);
		}
	}

	// Function to trigger the search based on the phone number value
	async function searchStaffByPhoneNumber() {
		const phoneInput = document.querySelector('#staffCardCollapse input#id_phone_number');
		const phoneNumber = phoneInput ? phoneInput.value.trim().replace(/\s+/g, '') : '';  // Strip whitespace

		// Check if the phone number is valid (at least 8 characters)
		if (phoneNumber.length >= 8 && isValidPhoneNumber(phoneNumber)) {
			// Call the method to get staff by phone number
			const staff = await api.getStaffByPhoneNumber(phoneNumber);

			// If staff is found, show error message
			if (staff.body.length > 0) {
				showErrorMessage(phoneInput, 'This phone number has already been used.');
			} else {
				removeErrorMessage(phoneInput);
			}
		} else {
			removeErrorMessage(phoneInput);
		}
	}

	// Trigger search for email on input change
	const emailInput = document.querySelector('#staffCardCollapse input#id_email');
	if (emailInput) {
		emailInput.addEventListener('input', searchStaffByEmail);  // Trigger on input change
	}

	// Trigger search for phone number on input change
	const phoneInput = document.querySelector('#staffCardCollapse input#id_phone_number');
	if (phoneInput) {
		phoneInput.addEventListener('input', searchStaffByPhoneNumber);  // Trigger on input change
	}
});
